import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const billFromValuesAdapter = getAdapter({ idFieldName: 'value' });

const billFromValuesSlice = createSlice({
  name: 'billFromValues',
  initialState: billFromValuesAdapter.getInitialState(),
  reducers: {
    setBillFromValues: (state, { payload: { billFromValues } }) => {
      billFromValuesAdapter.setAll(state, billFromValues);
    },
  },
});

const selectors = billFromValuesAdapter.getSelectors(({ billFromValues }) => billFromValues);

export const getBillFromValues = (state) => selectors.selectAll(state);

export const {
  setBillFromValues,
} = billFromValuesSlice.actions;

export default billFromValuesSlice.reducer;